export const CampaignObjectiveSetting = {
  properties: {
    CampaignObjectiveSettingType: {
      'bulk-upload-header': 'Campaign Objective Type',
    },
  },
};
